import { render, staticRenderFns } from "./ParagraphInputRenderer.vue?vue&type=template&id=e7dc8926"
import script from "./ParagraphInputRenderer.vue?vue&type=script&lang=js"
export * from "./ParagraphInputRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports